import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { SharedDocumentEvent } from './shared_document_events';

@Injectable({ providedIn: 'root' })
export class SharedDocumentEventProvider extends DomainEventProvider<SharedDocumentEvent> {}
